/**
 * Generic opener for <modal-dialog> based popups.
 *
 * Any element on the page can open a popup by matching it via one of:
 *   - a `data-popup-target="<popup-id>"` attribute, or
 *   - an `href="#<popup-id>"` anchor
 *
 * `<popup-id>` must match the `id` of a `modal-dialog` element (or subclass)
 * already present on the page, e.g. the `popup-trade-in-request` section.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-popup-target], a[href^="#"]');
  if (!trigger) return;

  const targetId = trigger.dataset.popupTarget || trigger.getAttribute('href').slice(1);
  if (!targetId) return;

  const popup = document.getElementById(targetId);
  if (!popup || typeof popup.show !== 'function') return;

  event.preventDefault();
  popup.show(trigger);
});
